import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import DataGrid, { Column, Scrolling } from 'devextreme-react/data-grid';

interface ShowModalProps {
    show: boolean;
    onClose: () => void;
    data: any[]; // updated to reflect an array
}

const ShowModal: React.FC<ShowModalProps> = ({ show, onClose, data }) => {
    const dataSource = Array.isArray(data) ? data : [];

    return (
        <Modal show={show} onHide={onClose} size="xl" centered backdrop="static">
            <Modal.Header closeButton>
                <Modal.Title>Product</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ maxHeight: '70vh', overflowY: 'auto' }}>
                <DataGrid
                    dataSource={dataSource}
                    keyExpr="id"
                    showBorders={true}
                    columnAutoWidth={true}
                    allowColumnResizing={true}
                >
                    <Scrolling
                        mode='standard'
                        useNative={true}
                        scrollByContent={true}
                        scrollByThumb={true}
                    />
                    <Column dataField="invoiceNo" caption="Invoice No" />
                    <Column dataField="soDate" caption="SO Date" dataType="date" format="dd/MM/yyyy" />
                    <Column dataField="diaWt" caption="Dia Wt" format="#,##0.000" />
                    <Column dataField="netWt" caption="Net Wt" format="#,##0.000" />
                    <Column dataField="diaQty" caption="Dia Qty" />
                    <Column dataField="grossWt" caption="Gross Wt" format="#,##0.000" />
                    <Column dataField="category" caption="Category" />
                    <Column dataField="style" caption="Style" />
                    <Column dataField="karat" caption="Kt" />
                    <Column dataField="igiNo" caption="IGI No" />
                    <Column dataField="huid" caption="HUID" />
                    <Column dataField="dpPrice" caption="DP Price" format="#,##0.00" />
                    <Column dataField="colorStonePrice" caption="Color Stone Price" format="#,##0.00" />
                    <Column dataField="diamondMrp" caption="Diamond Price" format="#,##0.00" />
                    <Column dataField="selingPrice" caption="Selling Price" format="#,##0.00" />
                    <Column dataField="isSRP" caption="SRP" />
                    <Column dataField="complexityName" caption="Complexity" />
                    <Column dataField="complexityPercentage" caption="Complexity %" format="#0.##" />
                    <Column dataField="materialType" caption="Material Type" />
                    <Column dataField="oLockerId" caption="Insurance Name" />
                    <Column dataField="olockerURL" caption="Insurance Policy"
                        cellRender={(cellData) => {
                            const url = cellData?.value;
                            if (url)
                                return (
                                    <a
                                        href={url}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        download
                                        style={{ color: "#0d6efd", textDecoration: "underline", cursor: "pointer" }}
                                    >
                                        Policy
                                    </a>
                                );
                        }}
                    />
                </DataGrid>
            </Modal.Body>
        </Modal>
    );
};

export default ShowModal;
